const LANGUAGE_BY_CODE: Record<string, string> = {
  ARA: 'Arabic',
  SPA: 'Spanish',
  VIE: 'Vietnamese',
  CMN: 'Mandarin',
  ZHO: 'Mandarin',
  YUE: 'Cantonese',
  HIN: 'Hindi',
  URD: 'Urdu',
  GUJ: 'Gujarati',
  PAN: 'Punjabi',
  IBO: 'Igbo',
  YOR: 'Yoruba',
  SOM: 'Somali',
  KOR: 'Korean',
  JPN: 'Japanese',
  TGL: 'Tagalog',
  POR: 'Portuguese',
  FRA: 'French',
  RUS: 'Russian',
  FAS: 'Persian',
  PRS: 'Dari',
  AMH: 'Amharic',
  SWA: 'Swahili',
  NEP: 'Nepali',
  KAR: 'Karen',
  HMN: 'Hmong',
  ENG: 'English',
};

function titleCase(value: string): string {
  return value
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function resolveNativeLanguage(raw: string): string {
  const value = raw.trim();
  if (value === '') return '';
  const upper = value.toUpperCase();
  if (LANGUAGE_BY_CODE[upper]) return LANGUAGE_BY_CODE[upper];
  if (value.length <= 3) return upper;
  return titleCase(value);
}
